<!--
  O mesmo que temos hoje
  Conteúdo será revisado posteriormente
  Tirar última frase em negrito da página de educ. infantil
-->
<template>
  <section v-if="segmento">
    <Banner value="Matrícula" />
    <hr style="border:5px solid #DDD" />

    <section style="background:#DDD">
      <v-container grid-list-xl>
        <v-layout row wrap my-4>
          <v-flex xs12>
            <p class="lead">
              É hora de começarmos uma história juntos! Abaixo organizamos tudo
              que você precisa saber para efetivar com sucesso a sua matrícula
              na Escola Engenho. Qualquer dúvida estamos a sua disposição. Basta
              <a href="/atendimento/fale-conosco">entrar em contato</a>.
            </p>
          </v-flex>
        </v-layout>
      </v-container>
    </section>

    <Vagas />

    <section style="background:none;">
      <v-container grid-list-xl>
        <v-layout justify-space-between row wrap my-4>
          <v-flex lg8>
            <h3>Período de Matrícula</h3>
            <table>
              <tr class="head">
                <td rowspan="2">PARA ALUNOS DA ESCOLA</td>
                <td colspan="2">PARA NOVOS ALUNOS</td>
              </tr>
              <tr class="head">
                <td>VAGAS REMANESCENTES<br />DE 2025 PARA 2026</td>
                <td>DEMAIS VAGAS 2026</td>
              </tr>
              <tr>
                <td>DE 22/09/2025<br />A 26/09/2025</td>
                <td>DE 22/09/2025<br />A 26/09/2025</td>
                <td>A PARTIR DE<br />01/10/2025</td>
              </tr>
            </table>

            <br />
            <br />
            <h3>Período de Atendimento</h3>
            <table>
              <tr>
                <td>
                  EDUCAÇÃO INFANTIL
                  <small style="display:block">(GTs I e II)</small>
                </td>
                <td>
                  ENSINO FUNDAMENTAL I
                  <small style="display:block">(do 1º ao 5º ano)</small>
                </td>
                <td>
                  ENSINO FUNDAMENTAL II
                  <small style="display:block">(do 6º ao 9º ano)</small>
                </td>
              </tr>
              <tr>
                <td colspan="2">PERÍODO VESPERTINO</td>
                <td>PERÍODO MATUTINO</td>
              </tr>
            </table>

            <br />
            <div>
              <h3>
                Documentação e procedimentos indispensáveis no ato de matrícula
                <small
                  >(os documentos poderão ser enviados de forma digital):</small
                >
              </h3>
              <ul>
                <li>
                  Cópia da
                  <b>Certidão de Nascimento</b> ou <b>RG</b> do <u>aluno</u>;
                </li>
                <li>
                  Cópia da
                  <b>Carteira de Vacinação</b> do <u>aluno</u>;
                </li>
                <li>
                  <b>Declaração de Frequência</b> acompanhada do
                  <b>Último boletim escolar</b> do <u>aluno</u> (para o Ensino
                  Fundamental, 1º ao 9º ano);
                </li>
                <li>
                  Declaração ou comprovante de quitação de débitos da Escola
                  anterior;
                </li>
                <li>
                  Cópia do
                  <b>CPF</b> do <u>responsável financeiro</u> (quem assinará o
                  contrato);
                </li>
                <li>
                  Cópia do
                  <b>Comprovante de Residência</b> do
                  <u>responsável financeiro</u>;
                </li>
                <li>
                  <b>Pagamento da parcela de janeiro 2026</b>, preferencialmente
                  à vista ou com cheque pré-datado para o dia 10/01/2026. O
                  pagamento também poderá ser realizado por agendamento de
                  transferência, boleto bancário ou cartão de débito/crédito.
                </li>
              </ul>
              <br />
              <h3>
                Documentos fornecidos pela escola que deverão estar preenchidos
                e assinados <small>(presencialmente ou de forma digital)</small>
              </h3>
              <ul>
                <li>
                  <b>Ficha de Matrícula {{ ano }}</b> totalmente preenchida e
                  assinada;
                </li>
                <li>
                  <b>Carta Circular {{ ano }}</b> assinada;
                </li>
                <li>
                  <b>Requerimento {{ ano }}</b> totalmente preenchido e
                  assinado;
                </li>
                <li>
                  <b
                    >Contrato de Prestação de Serviços de Educação Escolar
                    {{ ano }}</b
                  >
                  totalmente preenchido e assinado com rubricas nas páginas que
                  não contêm assinatura;
                </li>
              </ul>
              <p class="bloco">
                Todos estes documentos fornecidos pela Escola Engenho podem ser
                solicitados pelo e-mail:
                <b>engenho@escolaengenho.com.br</b> ou Whatsapp:
                <b>(48) 99124-5187.</b>
              </p>
              <br />
              <h3>
                Documentação exigida após a efetivação da matrícula
                <small
                  >(os documentos poderão ser enviados de forma digital)</small
                >
              </h3>
              <ul>
                <li>
                  <b>Atestado Médico</b>
                  de condições físicas para o ano de {{ ano }};
                </li>
                <li>
                  <b>Parecer Descritivo</b> da escola anterior (somente para o
                  1º ano);
                </li>
                <li><b>Histórico Escolar</b> original;</li>
                <li>
                  <b>Declaração de Conclusão</b> apto ano/série (caso já tenha
                  acabado o ano letivo na escola anterior).
                </li>
              </ul>
            </div>
            <br />
            <h3>
              Valores {{ ano }}
              <small></small>
            </h3>
            <table>
              <tr>
                <td>
                  EDUCAÇÃO INFANTIL
                  <small style="display:block">(GTs I e II)</small>
                </td>
                <td>
                  ENSINO FUNDAMENTAL I e II
                  <small style="display:block">(do 1º ao 9º ano)</small>
                </td>
              </tr>
              <tr>
                <td>
                  <small style="display:block; font-weight:bold;"
                    >MENSALIDADE</small
                  >
                  12 x R$ {{ valoresInfantil.mensal }}
                </td>
                <td>
                  <small style="display:block; font-weight:bold;"
                    >MENSALIDADE</small
                  >
                  12 x R$ {{ valoresFundamental.mensal }}
                </td>
              </tr>
              <tr>
                <td>
                  <small style="display:block; font-weight:bold;"
                    >ANUIDADE</small
                  >
                  R$ {{ valoresInfantil.anual }}
                </td>
                <td>
                  <small style="display:block; font-weight:bold;"
                    >ANUIDADE</small
                  >
                  R$ {{ valoresFundamental.anual }}
                </td>
              </tr>
            </table>
          </v-flex>
          <v-flex lg4>
            <Lateral :segmento="1" />
          </v-flex>
        </v-layout>
      </v-container>
    </section>
  </section>
</template>

<script>
import Banner from "../components/Banner";
import Lateral from "../components/matricula/Lateral";
import Vagas from "../components/matricula/Vagas";

import jsonData from "../../public/api/v1/segmento/2.json";

export default {
  data: () => ({
    segmento: null,
    ano: 2026,
    dia: "4 de janeiro de 2026",
    valoresInfantil: {
      mensal: "1.555,00",
      anual: "18.660,00",
    },
    valoresFundamental: {
      mensal: "1.555,00",
      anual: "18.660,00",
    },
  }),
  created: function() {
    this.segmento = jsonData;
  },
  components: {
    Banner,
    Lateral,
    Vagas,
  },
};
</script>

<style lang="scss" scoped>
a {
  text-decoration: none;
}
p,
h2,
ul li,
ol li {
  text-align: left !important;
}

ul,
ol {
  margin-bottom: 20px;
}

table {
  width: 100%;
  tr {
    &:first-child,
    &.head {
      td {
        color: white;
        font-weight: bold;
        background: #666;
        border: 1px solid #666;
      }
    }
    td {
      text-align: center;
      background: #fff;
      border: 1px solid #ddd;
      padding: 5px;
    }
  }
}

.img3d {
  width: 100%;
  transform: perspective(400px) rotateY(15deg);
  box-shadow: -5px 0px 10px #666;
}

h3 {
  line-height: 2.2rem;
  margin-bottom: 1rem;
  small {
    color: #777;
    font-size: 1.5rem;
    font-weight: 400;
  }
}

.bloco {
  // border: 1px solid black;
  border-radius: 1rem;
  padding: 1rem;
  background: lightgray;
}
</style>
